import { render, staticRenderFns } from "./HostedSignalingServer.vue?vue&type=template&id=389d098b&scoped=true"
import script from "./HostedSignalingServer.vue?vue&type=script&lang=js"
export * from "./HostedSignalingServer.vue?vue&type=script&lang=js"
import style0 from "./HostedSignalingServer.vue?vue&type=style&index=0&id=389d098b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d098b",
  null
  
)

export default component.exports